import { useEffect, useState } from "react";

const JITTER_PX = 6;
const TOP_ZONE_PX = 160;

/**
 * True while the visitor is scrolling down past the top of the page, false
 * the moment they scroll up: lets the phone bar get out of the way while
 * reading. Movements under a few pixels are ignored; reads once per frame.
 */
export function useTuckOnScroll() {
	const [tucked, setTucked] = useState(false);

	useEffect(() => {
		let last = window.scrollY;
		let ticking = false;
		const onScroll = () => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(() => {
				const y = window.scrollY;
				if (Math.abs(y - last) > JITTER_PX) {
					setTucked(y > last && y > TOP_ZONE_PX);
					last = y;
				}
				ticking = false;
			});
		};
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return tucked;
}
